<template>
  <wa-dropdown distance="5" :placement="placement">
    <wa-button
      variant="neutral"
      appearance="outlined"
      slot="trigger"
      data-testid="three-dots-vertical"
      :size="size"
      ><wa-icon
        library="bootstrap"
        :style="size === 's' ? `font-size: 14px` : `font-size: 18px`"
        name="three-dots-vertical"
    /></wa-button>
    <slot name="menu"></slot>
  </wa-dropdown>
</template>

<script setup>
defineProps({
  placement: {
    type: String,
    default: 'bottom-start'
  },
  size: {
    type: String,
    default: 'm'
  }
})
</script>

<style lang="postcss" scoped>
wa-button {
  &::part(base) {
    width: 40px;
    height: 40px;
    padding: 0;
    border-color: var(--wa-color-neutral-70);
  }

  &[size='s'] {
    &::part(base) {
      width: 30px;
      height: 30px;
    }
  }

  &[size='l'] {
    &::part(base) {
      width: 50px;
    }
  }

  &::part(label) {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 var(--wa-space-s);
  }
}

:deep(wa-dropdown-item) {
  padding-left: var(--wa-space-m);
  padding-right: var(--wa-space-m);
  font-size: var(--wa-font-size-s);
  &::part(checkmark),
  &::part(submenu-icon) {
    display: none;
  }

  /* this is covering usage of phosporicons on menu item  because slot suffix/prefix is not applied for the icon */
  &::part(label) {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
